/* CurbGo search: placement (desktop header-actions / mobile sticky header row) + flashing suggestions. Loaded globally from layout so it survives header section re-renders. 2026-07-24 fix: keep a reference to the form and re-place it after cart/header re-renders (MutationObserver), so add-to-cart no longer removes the search bar. */
(function(){
  function q(s){return document.querySelector(s);}
  var S=["contemporary bar stools","grannychic furniture","blue dining dishes","cast iron dutch oven","tower fan","stainless cookware set","mid-century desk chair","farmhouse dinnerware"];
  var mq=window.matchMedia('(max-width:749px)');
  var savedForm=null;
  function pick(){
    var forms=document.querySelectorAll('.cg-srch__form');
    var form=null;
    for(var j=0;j<forms.length;j++){ if(!form){ form=forms[j]; } else if(forms[j].parentElement){ forms[j].parentElement.removeChild(forms[j]); } }
    if(!form) form=savedForm;
    if(form) savedForm=form;
    return form;
  }
  function place(){
    var form=pick(); if(!form) return;
    var home=q('.cg-search-row-section .cg-srch');
    var actions=q('header-actions');
    var rb=q('.header__row--bottom');
    if(mq.matches && rb){ if(form.parentElement!==rb) rb.appendChild(form); if(home) home.style.display='none'; }
    else if(actions){ if(form.parentElement!==actions) actions.insertBefore(form, actions.firstChild); if(home) home.style.display='none'; }
    else if(home){ if(form.parentElement!==home) home.appendChild(form); home.style.display=''; }
  }
  var i=0;
  function flashTick(){
    var ph=q('.cg-srch__ph'); var cyc=ph?ph.querySelector('.cyc'):null;
    if(!ph||!cyc||ph.classList.contains('hide')) return;
    cyc.classList.add('fade');
    setTimeout(function(){ i=(i+1)%S.length; cyc.textContent=S[i]; cyc.classList.remove('fade'); },360);
  }
  function onField(e,fn){ var t=e.target; if(t&&t.classList&&t.classList.contains('cg-srch__input')){ var ph=q('.cg-srch__ph'); if(ph) fn(ph,t); } }
  var moT=null;
  function watch(){
    try{
      var mo=new MutationObserver(function(){
        if(moT) return;
        moT=setTimeout(function(){ moT=null; place(); },150);
      });
      mo.observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  }
  function boot(){
    place();
    if(mq.addEventListener) mq.addEventListener('change',place); else if(mq.addListener) mq.addListener(place);
    window.addEventListener('resize',place);
    setInterval(flashTick,2600);
    document.addEventListener('focusin',function(e){ onField(e,function(ph){ ph.classList.add('hide'); }); });
    document.addEventListener('focusout',function(e){ onField(e,function(ph,t){ if(!t.value) ph.classList.remove('hide'); }); });
    document.addEventListener('input',function(e){ onField(e,function(ph,t){ ph.classList.toggle('hide', t.value.length>0); }); });
    document.addEventListener('cart:update',place);
    var n=0, ri=setInterval(function(){ place(); if(++n>=15) clearInterval(ri); },400);
    watch();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
